import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { api } from '@/lib/api';
import { downloadXlsx } from '@/lib/download';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const EMPTY = { date_from: '', date_to: '', status: '', carrier: '', mode: '', place: '', operator_id: '', seller_id: '' };

const Sel = ({ label, value, onChange, options, testid }) => (
  <label className="flex flex-col gap-1 text-xs font-semibold text-slate-700">{label}
    <select value={value} onChange={e => onChange(e.target.value)} className="h-9 w-48 border border-slate-300 bg-white px-2 text-sm font-normal" data-testid={testid}>
      <option value="">Todos</option>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </label>
);

// Exporta a Excel todo el seguimiento (Modalidad 1 y 2) que coincida con los filtros. Solo administradores.
export const ShipmentsExport = () => {
  const [f, setF] = useState(EMPTY);
  const [opt, setOpt] = useState({ operators: [], sellers: [], carriers: [], statuses: [] });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/admin/shipments/export/options').then(r => setOpt(r.data)).catch(() => {}); }, []);
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const run = async () => {
    setBusy(true);
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    await downloadXlsx('/admin/shipments/export', `seguimiento_envios_${new Date().toISOString().slice(0, 10)}.xlsx`, params);
    setBusy(false);
  };
  return (
    <div className="mb-6 border border-slate-200 bg-white p-4" data-testid="shipments-export">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Exportar seguimiento a Excel</div>
      <p className="mt-1 text-xs text-slate-500">Incluye todos los pedidos con envío (vendedor y AutoMarket) que coincidan con los filtros, con datos de contacto y valores. El rango usa la fecha del pedido.</p>
      <div className="mt-3 flex flex-wrap items-end gap-3">
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-700">Desde
          <Input type="date" value={f.date_from} onChange={e => set('date_from')(e.target.value)} className="rounded-none h-9 w-40" data-testid="export-date-from" />
        </label>
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-700">Hasta
          <Input type="date" value={f.date_to} onChange={e => set('date_to')(e.target.value)} className="rounded-none h-9 w-40" data-testid="export-date-to" />
        </label>
        <Sel label="Estado del envío" value={f.status} onChange={set('status')} options={opt.statuses.map(s => [s.key, s.label])} testid="export-status" />
        <Sel label="Modalidad" value={f.mode} onChange={set('mode')} options={[['seller', 'Gestionado por el vendedor'], ['automarket', 'Gestionado por AutoMarket']]} testid="export-mode" />
        <Sel label="Transportadora" value={f.carrier} onChange={set('carrier')} options={opt.carriers.map(c => [c, c])} testid="export-carrier" />
        <Sel label="Operador logístico" value={f.operator_id} onChange={set('operator_id')} options={opt.operators.map(o => [o.user_id, o.name])} testid="export-operator" />
        <Sel label="Vendedor" value={f.seller_id} onChange={set('seller_id')} options={opt.sellers.map(s => [s.user_id, s.name])} testid="export-seller" />
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-700">Ciudad o departamento
          <Input value={f.place} onChange={e => set('place')(e.target.value)} placeholder="Origen o destino" className="rounded-none h-9 w-48" data-testid="export-place" />
        </label>
        <Button onClick={run} disabled={busy} className="rounded-none bg-emerald-700 hover:bg-emerald-800 h-9" data-testid="export-excel-btn">
          <Download className="h-4 w-4 mr-1" /> {busy ? 'Generando…' : 'Exportar a Excel'}
        </Button>
        <Button variant="ghost" className="rounded-none h-9 text-xs" onClick={() => setF(EMPTY)} data-testid="export-clear">Limpiar filtros</Button>
      </div>
    </div>
  );
};
